import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { Flow } from 'signup-constants/Flow';
import { getRouteParams } from '../routing/getRouteParams';
import { getTrialName } from '../trial/updateFormFieldsTrialInformation';
export const getSidepanelTitleKey = () => {
  const {
    flowKey,
    integrationKey,
    microappKey
  } = getRouteParams();
  const trialName = getTrialName();
  let sidePanelTitleKey = `sidepanel.hubType.${flowKey}.title`;
  if (microappKey) {
    sidePanelTitleKey = `sidepanel.hubType.${flowKey}.${microappKey}.title`;
  }
  if (integrationKey) {
    sidePanelTitleKey = `sidepanel.hubType.${flowKey}.${integrationKey}.title`;
  }
  if (flowKey === Flow.Trial && !trialName) {
    sidePanelTitleKey = `sidepanel.hubType.${Flow.Crm}.title`;
  }
  const isSidePanelTitleValid = isValidI18nKey(sidePanelTitleKey);
  sidePanelTitleKey = isSidePanelTitleValid ? sidePanelTitleKey : `sidepanel.hubType.${Flow.Crm}.title`;
  return {
    sidePanelTitleKey,
    titleOptions: {
      trialName
    }
  };
};